export function extractEntityId(furl: string) {
  const furlSplit = furl.split("-");
  return Number.parseInt(furlSplit[0]);
}
